/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PricingResponse {
    getFixupPrototypeFunction() { return PricingResponse.fixupPrototype; }

    static newInstance(model: Partial<PricingResponse>): PricingResponse {
        let obj = Object.assign(new PricingResponse(), model);
        PricingResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PricingResponse>): PricingResponse {
        if (!model) return null;
        return PricingResponse.newInstance(<PricingResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PricingResponse) {
        if (!obj) return;

        models.PricingResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PricingResponse): boolean {
        Object.setPrototypeOf(obj, PricingResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.rates) {
            for (let val of this.rates) {
                models.PricingRateItem.fixupPrototype(val);
            }
        }
    }

    /**
     * Canonical SKU identifier e.g. AWS#EC2#us-east-1#m5.xlarge
     */
    sku_id: string;

    /**
     * aws | azure
     */
    provider: string;

    /**
     * AWS service code e.g. AmazonEC2, AmazonRDS
     */
    servicecode: string;

    /**
     * Instance / node type e.g. m5.xlarge
     */
    sku_name: string;

    /**
     * Region code e.g. us-east-1
     */
    region: string;

    /**
     * Human-readable location e.g. US East (N. Virginia)
     */
    location: string;

    /**
     * Always USD
     */
    currency: string;

    /**
     * hours | gb-mo | requests
     */
    unit: string;

    /**
     * mongodb
     */
    data_source: string;

    /**
     * ISO 8601 timestamp of the cached record
     */
    as_of: string;

    /**
     * \"approximate\" for EC2, \"exact\" for all other services
     */
    match_confidence: string;

    /**
     * One entry per pricing dimension
     */
    rates: Array<models.PricingRateItem>;

    /**
     * Service-specific attributes: vcpu, memory_gib, database_engine, etc.
     */
    attributes: any;

}
